import { useServices } from '@/app/providers';
import { usePaginatedList } from '@/shared/hooks';
import type { RoutineExecution } from '@yawi/types';

export function useExecutionList(jobId: string) {
  const { routineExecutionRepo } = useServices();

  return usePaginatedList<RoutineExecution>({
    fetchFn: (params) => routineExecutionRepo.list({ ...params, jobId }),
    errorTitle: 'Error al cargar ejecuciones',
  });
}
